import { Component } from '@angular/core';
import { AuthorsService } from '../authors.service';
import { Author } from '../author';

@Component({
  selector: 'app-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.css']
})
export class AuthorsComponent {
  constructor(public authorService: AuthorsService) { }

  allAuthors = this.authorService.allAuthors$

  addAuthor() {
    this.authorService.keepFocus = true
    this.authorService.selectedAuthor = undefined
    this.authorService.addingNewAuthor = true
  }

  selectAuthor(author: Author) {
    this.authorService.addingNewAuthor = false
    this.authorService.selectedAuthor = author
  }
}
